import identifyQualifiedTraffic from "@utils/identifyQualifiedTraffic";
import { handleCustomUDL } from "@utils/UDLUtils";

export class RotatorSlide {
  private el: HTMLElement;

  constructor(el: HTMLElement) {
    this.el = el;
  }

  init(): void {
    this.el
      .querySelectorAll<HTMLAnchorElement>(".comp-button[data-event-tracking='true'] a.button")
      .forEach((linkElement) => {
        linkElement.addEventListener("click", () => {
          const slideParams = this.getCommonParameters(linkElement);
          const customParams = { ...linkElement.dataset };

          Object.assign(slideParams, customParams);
          this.pushData(slideParams);
        });
      });
  }

  destroy(): void { }

  private getCommonParameters(linkElement: HTMLAnchorElement) {
    const link_url = linkElement.href || linkElement.getAttribute("href") || "";

    return {
      title: this.replaceNewLineSign(
        this.el.querySelector(".title")?.textContent || ""
      ),
      description: this.replaceNewLineSign(
        this.el.querySelector(".sub-title")?.textContent || ""
      ),
      link_url: link_url,
      link_text: this.replaceNewLineSign(linkElement.textContent || ""),
      ...identifyQualifiedTraffic(link_url),
    };
  }

  private pushData(slideParams: any): void {
    handleCustomUDL("rotator_component_click", slideParams);
  }

  private replaceNewLineSign(text: string): string {
    return text ? text.replace(/\n/g, " ").trim() : "";
  }

  static initAll(root: Document | HTMLElement = document): void {
    root
      .querySelectorAll<HTMLElement>('[data-component="rotator-slide"]')
      .forEach((el) => {
        new RotatorSlide(el).init();
      });
  }
}